import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/handbook/handbook/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "getting-to-know-a-team"
    }}>{`Getting to know a team`}</h2>
    <p>{`These are some questions I've put together while chatting to folks about their experiences in leadership (particularly engineering leadership).`}</p>
    <p>{`I found them to be useful starting points for learning about how a team functions. The list is too long to try get through it all, but that's not the idea - the important thing is to ask a question about a topic you're interested in and then get inquisitive about what they say to keep diving deeper.
e.g.`}</p>
    <ul>
      <li parentName="ul">{`When did you adopt that approach?"`}</li>
      <li parentName="ul">{`What made you adopt that approach?`}</li>
      <li parentName="ul">{`How did the team react when you told them about that approach?`}</li>
      <li parentName="ul">{`What successes have you had since adopting that approach?`}</li>
      <li parentName="ul">{`Any lessons learned you'd give as advice to others who might do the same?`}</li>
    </ul>
    <hr></hr>
    <h2 {...{
      "id": "the-questions"
    }}>{`The questions`}</h2>
    <h3 {...{
      "id": "the-general-stuff"
    }}>{`The general stuff`}</h3>
    <ul>
      <li parentName="ul">{`What size is your team?`}</li>
      <li parentName="ul">{`How do you structure your teams? By project? Feature? System? Skills?`}</li>
      <li parentName="ul">{`Do you have any team ceremonies?`}</li>
    </ul>
    <hr></hr>
    <h3 {...{
      "id": "engineering-process"
    }}>{`Engineering process`}</h3>
    <ul>
      <li parentName="ul">{`What does your development process look like? Can you describe how a feature goes from idea / request to live in prod?`}</li>
      <li parentName="ul">{`What is your CI/CD approach?`}</li>
      <li parentName="ul">{`What is your approach for different environments (develop, staging, preview, etc)?`}</li>
      <li parentName="ul">{`What's your QA process, especially when working on new projects?`}</li>
      <li parentName="ul">{`Do you have an official process for discussing / deciding larger architectural pieces? Do you have specific roles for this?`}</li>
      <li parentName="ul">{`What is your infrastructure change control process?`}</li>
      <li parentName="ul">{`Do you have a good culture of documentation? How do your processes drive this?`}</li>
      <li parentName="ul">{`Do your product / design and engineering teams work closely together? How do they collab on new features, projects, products, etc?`}</li>
      <li parentName="ul">{`Do you encourage pair programming?`}</li>
      <li parentName="ul">{`What is the working relationship between development and devops / infra?`}</li>
      <li parentName="ul">{`Do you use a Design System? When was it first introduced? Is it something that generally has a high level of buy-in from engineers?`}</li>
    </ul>
    <hr></hr>
    <h3 {...{
      "id": "agile"
    }}>{`Agile`}</h3>
    <ul>
      <li parentName="ul">{`Do you subscribe to any of the Agile values?`}</li>
      <li parentName="ul">{`What practices from the toolbelt do you implement?`}</li>
      <li parentName="ul">{`What ceremonies do you perform?`}</li>
      <li parentName="ul">{`Do you have any processes / practices that you'd consider non-standard or uncommon?`}</li>
      <li parentName="ul">{`Do you use sprint goals? What approach do you use to make it not just describe the work included?`}</li>
    </ul>
    <hr></hr>
    <h3 {...{
      "id": "operations"
    }}>{`Operations`}</h3>
    <ul>
      <li parentName="ul">{`How do you make progress on work that touches various projects available to non-devs?`}</li>
      <li parentName="ul">{`Do you actively try to minimise handoffs? If so, how?`}</li>
      <li parentName="ul">{`Do you set team or individual OKRs? Do you find them effective?`}</li>
      <li parentName="ul">{`How committed to writing and maintaining specs are you? Who owns them?`}</li>
    </ul>
    <hr></hr>
    <h3 {...{
      "id": "leadership"
    }}>{`Leadership`}</h3>
    <ul>
      <li parentName="ul">{`What does success in your role look like? What are your core responsibilities?`}</li>
      <li parentName="ul">{`What have you found to be the biggest factors to engineering retention in your organisation?`}</li>
      <li parentName="ul">{`How often do you have 1:1s with your team?`}</li>
    </ul>
    <hr></hr>
    <h3 {...{
      "id": "startups--growth"
    }}>{`Startups / Growth`}</h3>
    <ul>
      <li parentName="ul">{`Are there roles that you think are overlooked in smaller, growing teams? Skills that you think generally should be brought on board sooner than they are?`}</li>
      <li parentName="ul">{`What are the most common pitfalls you've seen in established teams that you've joined?`}</li>
      <li parentName="ul">{`Any common blindspots that you've seen in teams migrating from being scrappy startup to more established process-bound organisations?`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      